import {
  ButtonSize,
  ButtonType,
  OutlinedButton,
} from '@prisjakt/ui/button/variants';
import React from 'react';
import type { Experiment } from './context';
import { ExperimentSelectWrapper } from './styles';

type ExperimentSelectProps = {
  experiment: Experiment<unknown>;
  selectedVariant?: string;
  onClick: (variant: string) => void;
};

export const ExperimentSelect: React.FC<ExperimentSelectProps> = ({
  experiment,
  selectedVariant,
  onClick,
}) => {
  const selected = selectedVariant ?? 'baseline';

  return (
    <ExperimentSelectWrapper>
      {['baseline'].concat(Object.keys(experiment.variants)).map(variant => (
        <OutlinedButton
          key={variant}
          size={ButtonSize.SMALL}
          type={variant === selected ? ButtonType.PRIMARY : undefined}
          onClick={() => onClick?.(variant)}
        >
          {variant}
        </OutlinedButton>
      ))}
    </ExperimentSelectWrapper>
  );
};
